// Frontend constants for structure prediction models
// Keep in sync with StructurePredictionModel in benchling/molbio/proteins/models/structure_prediction_run.py

export enum StructurePredictionModel {
  ALPHAFOLD = 'alphafold',
  CHAI1 = 'chai1',
}

const STRUCTURE_PREDICTION_MODEL_DISPLAY_NAMES: {[model in StructurePredictionModel]: string} = {
  [StructurePredictionModel.ALPHAFOLD]: 'AlphaFold2',
  [StructurePredictionModel.CHAI1]: 'Chai-1',
};

/**
 * Get the user-friendly display name for a structure prediction model.
 * Falls back to the original model string if not found in the mapping.
 */
export function getModelDisplayName(model: string): string {
  return STRUCTURE_PREDICTION_MODEL_DISPLAY_NAMES[model as StructurePredictionModel] ?? model;
}
